import React from 'react';
import { LoginSection } from './LoginSection';
import '../styles/WelcomeScreen.css';

export const WelcomeScreen: React.FC = () => {
  // WelcomeScreen is now only used for login
  // The main app shows MainEditorView directly after login
  return <LoginSection />;
};
